export const GENDER_TYPE = {
    MALE: 1,
    FAMALE: 2,
}

export const USER_TYPE = {
    ADMIN: 1,
    NORMAL: 2,
    TEST: 3,
}

export const LOCK_TYPE = {
    NORMAL: false,
    LOCKED: true,
}